import { styled } from "@mui/material";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import HeaderImage from "../Images/Header Image.png";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import card_img from "../Images/card_img.png";
import "../style.css";

const card_data = [
  {
    card_img: card_img,
    card_title: "Reach more customers",
    card_des:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
  },
  {
    card_img: card_img,
    card_title: "Reach more customers",
    card_des:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
  },
  {
    card_img: card_img,
    card_title: "Expand your business wider",
    card_des:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
  },
  {
    card_img: card_img,
    card_title: "Build your brand",
    card_des:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
  },
];
const H1 = styled(Typography)((theme) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "56px;",
  lineHeight: "110%",
  letterSpacing: "-0.01em;",
  color: "#000000;",
}));

const H2 = styled(Typography)((theme) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "40px",
  lineHeight: "125%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const H3 = styled(Typography)(({ theme }) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "24px",
  lineHeight: "150%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const H4 = styled(Typography)(({ theme }) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "20px",
  lineHeight: "150%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const P = styled(Typography)(({ theme }) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "150%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const Btn = styled(Button)(({ theme }) => ({
  padding: "5px 20px;",
  border: "1px solid #559A95;",
  backgroundColor: "#2B817B",
  fontSize: "20px;",
  fontWeight: "600",
  borderRadius: "8px;",
  color: "white",
}));

function BussniessWithEatCost() {
  return (
    <>
      <Container maxWidth="xl">
        <H2
          sx={{
            fontSize: { lg: "40px", md: "30px", sm: "20px", xs: "20px" },
            my: "10px",
          }}
        >
          Do more for your business with <br /> EatCoast
        </H2>
      </Container>
      <Container
        className="cardContainer"
        sx={{
          display: "flex",
          justifyContent: {
            lg: "space-between",
            md: "space-between",
            sm: "center",
            xs: "center",
          },
          flexWrap: "wrap",
          marginTop: 3,
          alignItems: "center",
        }}
        maxWidth="xl"
      >
        {card_data.map((item, index) => {
          return (
            <Card
              className="cards"
              sx={{
                width: "350px",
                padding: 1,
                border: "1px solid #E1E1E6;",
                marginBottom: 3,
              }}
            >
              <CardMedia component="img" image={item.card_img} />
              <CardContent>
                <H4
                  sx={{
                    fontSize: { lg: "20px" },
                    md: "20px",
                    sm: "16px",
                    xs: "16px",
                  }}
                >
                  {item.card_title}
                </H4>
                <P
                  sx={{
                    fontSize: "16px",
                    color: "#545359",
                    textAlign: "justify",
                  }}
                >
                  {item.card_des}
                </P>
              </CardContent>
            </Card>
          );
        })}
      </Container>
    </>
  );
}

export default BussniessWithEatCost;
